import './PreContact.scss'
import imageOne from '../../../assets/images/contact/image-contact.png'
import imageTwo from '../../../assets/images/contact/image-contact-2.png'

const PreContact = () => {
  return (
    <div className="pre-contact-container">
      <div className="pre-contact-card card-green">
        <img
          src={imageOne}
          alt="Trabalhe conosco"
          className="pre-contact-img"
        />
        <div className="pre-contact-label">Trabalhe conosco</div>
      </div>
      <div className="pre-contact-card card-red">
        <img
          src={imageTwo}
          alt="Seja voluntário(a)"
          className="pre-contact-img"
        />
        <div className="pre-contact-label">Seja voluntário(a)</div>
      </div>
    </div>
  )
}

export default PreContact
